import { ShieldAlertOutlineIcon } from './ShieldAlertOutlineIcon';

/**
 * author: Peter Noble
 * id 51584101-DF6C-49FF-8ACB-13F7064DEE89
 * name shield-alert-outline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-alert-outline.svg
 * tags
 * - Alert / Error 
 */
export const ShieldWarningOutlineIcon = ShieldAlertOutlineIcon;
export default ShieldWarningOutlineIcon